import { makeStyles } from "@material-ui/core";

import { theme } from "theme";

export const useStyles = makeStyles((muiTheme) => ({
  root: {
    height: "40px",
    borderRadius: 0,

    "&.Mui-disabled": {
      opacity: 0.6,

      "&.MuiButton-contained": {
        "&.MuiButton-containedPrimary": {
          color: muiTheme.palette.common.black,
          backgroundColor: muiTheme.palette.primary.main,
        },
      },

      "&.MuiButton-outlined": {
        "&.MuiButton-outlinedPrimary": {
          borderColor: muiTheme.palette.primary.main,
          color: muiTheme.palette.primary.main,
        },
      },
    },
  },

  content: {
    display: "flex",
  },

  loader: {
    "&.MuiCircularProgress-colorPrimary": {
      color: theme.colors.light700,
    },
  },
}));
